import { useState, useEffect } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';
// material
import {
  Card,
  Table,
  Stack,
  Button,
  CircularProgress,
  TableRow,
  TableHead,
  TableBody,
  TableCell,
  Icon,
  Typography,
  TableContainer,
  TablePagination,
  TextField,
  Grid,
  IconButton,
  Tooltip,
} from '@mui/material';
import { Box } from '@mui/system';
import { Refresh } from '@mui/icons-material';
import CopyToClipboard from 'react-copy-to-clipboard';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Filter from '../filters/PendingPayments';

// components
import Page from '../Page';
import Scrollbar from '../Scrollbar';
import Iconify from '../Iconify';
import { fNumber } from '../../utils/formatNumber';

export default function PendingRpcPayments() {
  const navigate = useNavigate();
  const [paymentData, setpaymentData] = useState();
  const [pages, setPages] = useState(0);
  const [paymentCount, setpaymentCount] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [size, setSize] = useState(10);
  const [options, setOptions] = useState({ size, page: 0, plan: 'RILL_PARTNERS_CLUB' });
  const [input, setInput] = useState(1);

  const handlePageChange = (event, newPage) => {
    const temp = { ...options, page: newPage };
    setPages(newPage);
    setOptions(temp);
    getpayments(temp);
  };

  const getpayments = (options) => {
    setIsLoading(true);
    axios
      .get(`${process.env.REACT_APP_API_URL}/investment/pending`, {
        params: options,
      })
      .then((res) => {
        console.log('res', res);
        if (res.data.isError === false) {
          setIsLoading(false);
          setpaymentCount(res.data.data.maxRecords);
          setpaymentData(res.data.data.payments);
        }
      })
      .catch((err) => {
        console.log(err);
        setIsLoading(false);
      });
  };

  const handleSizeChange = (event) => {
    const temp = { ...options, size: event.target.value, page: 0 };
    setPages(0);
    setSize(event.target.value);
    setOptions(temp);
    getpayments(temp);
  };

  const goToPage = () => {
    console.log('hi');
    if (input > Math.ceil(paymentCount / size)) {
      return;
    }
    setInput(input > 0 ? input : 1);
    setPages(input - 1 >= 0 ? input - 1 : 0);
    const temp = { ...options, page: input - 1 };
    setOptions(temp);
    getpayments(temp);
  };

  const applyFilters = (filter) => {
    console.log('filter', filter);
    const temp = { page: 0, size, plan: 'RILL_PARTNERS_CLUB' };
    if (filter.userId.length) {
      temp.userId = filter.userId;
    }
    if (filter.clubId.length) {
      temp.clubId = filter.clubId;
    }
    if (filter.fullname.length) {
      temp.fullname = filter.fullname.trim();
    }
    if (filter.phone.length) {
      temp.phone = filter.phone;
    }
    if (filter.email.length) {
      temp.email = filter.email;
    }
    if (filter.paymentMethod.length) {
      temp.paymentMethod = filter.paymentMethod;
    }
    if (filter.startDate.length) {
      temp.startDate = filter.startDate;
    }
    if (filter.endDate.length) {
      temp.endDate = filter.endDate;
    }

    setOptions(temp);
    setPages(0);
    getpayments(temp);
  };
  const handleRefresh = () => {
    const temp = { size, page: 0, plan: 'RILL_PARTNERS_CLUB' };
    setOptions(temp);
    setPages(0);
    getpayments(temp);
  };
  useEffect(() => {
    getpayments(options);
  }, []);
  return (
    <>
      <Page title="payment">
        {isLoading ? (
          <div
            style={{
              width: '100%',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              height: '50vh',
            }}
          >
            <CircularProgress />
          </div>
        ) : (
          <>
            <Card>
              <Stack direction="row" justifyContent="space-between" alignItems="center">
                <Stack direction="row" spacing={2} padding={2}>
                  <TextField
                    size="small"
                    style={{ maxWidth: '100px', maxHeight: '35px' }}
                    type="number"
                    component="div"
                    label="Go to"
                    value={input}
                    onInput={(e) => setInput(e.target.value)}
                  />
                  <Button variant="contained" onClick={goToPage} style={{ maxHeight: '35px' }}>
                    Go
                  </Button>
                </Stack>
                <Stack padding={1} direction="row" justifyContent="flex-end" spacing={2} alignItems="center">
                  <Button
                    variant="contained"
                    size="small"
                    endIcon={<Refresh />}
                    onClick={() => handleRefresh()}
                    style={{ maxHeight: '35px' }}
                  >
                    Refresh
                  </Button>
                  <Filter applyFilters={applyFilters} />
                </Stack>
              </Stack>

              <Scrollbar>
                <TableContainer sx={{ minWidth: 800 }}>
                  <Table>
                    {/* <paymentListHead /> */}
                    <TableHead>
                      <TableRow>
                        <TableCell>Sl No</TableCell>
                        <TableCell>User ID</TableCell>
                        <TableCell>IF Number</TableCell>
                        <TableCell>Fullname</TableCell>
                        <TableCell>Phone</TableCell>
                        <TableCell>Category</TableCell>
                        <TableCell>Payment Method</TableCell>
                        <TableCell>Due Count</TableCell>
                        <TableCell>Due Amount</TableCell>
                        <TableCell>Actions</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {paymentData?.map((item, id) => (
                        <TableRow key={id}>
                          <TableCell style={{ width: '50px' }}>{pages * size + (id + 1)}</TableCell>

                          <TableCell style={{ cursor: 'pointer', width: '75px' }}>
                            <Stack direction="row" width="80px">
                              <Tooltip title="View User">
                                <IconButton onClick={() => navigate(`/dashboard/user/${item.userId}`)}>
                                  <Iconify icon="mdi:user" style={{ height: '22px', width: '22px', color: 'green' }} />
                                </IconButton>
                              </Tooltip>

                              <CopyToClipboard text={item.userId} onCopy={() => toast.info('User id copied')}>
                                <Tooltip title="Copy User ID">
                                  <IconButton>
                                    <Iconify
                                      icon="lucide:clipboard-copy"
                                      style={{ height: '22px', width: '22px', color: '#09ADBD' }}
                                    />
                                  </IconButton>
                                </Tooltip>
                              </CopyToClipboard>
                            </Stack>
                          </TableCell>
                          <TableCell>
                            <CopyToClipboard text={item?.clubId} onCopy={() => toast.info('IF Number copied')}>
                              <Typography sx={{ color: '#09ADBD', cursor: 'pointer' }} variant="p">
                                {item?.clubId}
                              </Typography>
                            </CopyToClipboard>
                          </TableCell>
                          <TableCell sx={{ wordBreak: 'break-all' }}>{item?.fullname?.toUpperCase()}</TableCell>
                          <TableCell>{item?.phone}</TableCell>
                          <TableCell>{item?.plan?.replaceAll('_', ' ')}</TableCell>
                          <TableCell>{item?.paymentMethod}</TableCell>
                          <TableCell>{item?.dueCount}</TableCell>
                          <TableCell>{`₹${fNumber(item?.dueAmount)}`}</TableCell>
                          <TableCell>
                            <Box>
                              <Link
                                to={`/dashboard/user/${item.userId}?section=${
                                  item.plan === 'RILL_FOUNDERS_CLUB' ? 'investmentf' : 'investmentp'
                                }`}
                              >
                                <Icon sx={{ color: 'gray' }}>
                                  <RemoveRedEyeIcon />
                                </Icon>
                              </Link>
                            </Box>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Scrollbar>
              <TablePagination
                rowsPerPageOptions={[10, 25, 50, 100]}
                onRowsPerPageChange={handleSizeChange}
                component={'div'}
                count={paymentCount}
                showFirstButton
                showLastButton
                onPageChange={handlePageChange}
                rowsPerPage={size}
                page={pages}
              />
            </Card>
          </>
        )}
      </Page>
    </>
  );
}
